type ProcessedErrorMessage = {
  firstLine: string;
  additionalLines: string[];
  hasMultipleLines: boolean;
};

export const processErrorMessage = (message: string): ProcessedErrorMessage => {
  const lines = message.split('\n').filter((line) => line.trim().length > 0);

  return {
    additionalLines: lines.slice(1),
    firstLine: lines[0] || 'Unknown error',
    hasMultipleLines: lines.length > 1,
  };
};

export const extractErrorMessage = (error: unknown): string => {
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const errorObj = error as {
      message: unknown;
    };
    if (typeof errorObj.message === 'string') {
      return errorObj.message;
    }
  }
  return 'An unknown error occurred';
};
